import { ServiceAreasTable } from "@/features/service-areas/service-areas-table";

const ServiceAreasScreen = () => {
  return (
    <div className="p-4">
      <ServiceAreasTable />
    </div>
  );
};

export default ServiceAreasScreen;
